/**
 * @generated SignedSource<<cb28f26c1ca7292c5219e38ecf8b7ea3>>
 * @relayHash f71176804f0f8510a7464cc538777917
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1

import type { ConcreteRequest } from 'relay-runtime';
export type PublicLinkPermissionsObjectType = "CONTENT" | "%future added value";
export type PublicLinkPermissionsType = "EDIT" | "VIEW" | "VIEW_AND_COMMENT" | "%future added value";
export type usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery$variables = {
  objectId: string;
  objectType: PublicLinkPermissionsObjectType;
};
export type usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery$data = {
  readonly publicLinkPermissionsForObject: {
    readonly permissions: ReadonlyArray<PublicLinkPermissionsType>;
  } | null;
};
export type usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery = {
  response: usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery$data;
  variables: usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "objectId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "objectType"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "objectId",
        "variableName": "objectId"
      },
      {
        "kind": "Variable",
        "name": "objectType",
        "variableName": "objectType"
      }
    ],
    "concreteType": "PublicLinkPermissions",
    "kind": "LinkedField",
    "name": "publicLinkPermissionsForObject",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "permissions"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f71176804f0f8510a7464cc538777917",
    "id": "52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1",
    "metadata": {},
    "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
    "operationKind": "query",
    "text": "query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!,$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId,objectType:$objectType){permissions}}"
  }
};
})();

(node as any).hash = "374477f8db79649c77f638ae2ac0ca9b";

export default node;
